import { takeEvery, put, fork } from "redux-saga/effects";
import * as actions from "../actions/SparePartExcelActions";
import * as api from "../../api/SparePartExcelApi";
import moment from "moment";
import { setBackdrop, resetBackdrop } from "../actions/BackdropActions";
import { showSuccessSnackbar, showErrorSnackbar } from "../actions/SnackbarActions";

function* getExcelList(action) {
    yield put(resetBackdrop());
    try {
        console.log("action.payload", action.payload);
        const { data } = yield api.postSparePartExcelToList(action.payload.data);
        yield put(actions.setExcelList(data || undefined));
    } catch (error) {
        yield put(showErrorSnackbar(error, "error"));
    }
    yield put(setBackdrop());
}

function* getPostExcelUpload(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.postSparePartExcelUpload(action.payload.fileChecksum);
        yield put(actions.setPostExcelUpload(data || undefined));
        yield put(showSuccessSnackbar(data.message));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* downloadExcelFile(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.downloadSparePartExcel(action.payload);
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = url;
        const filename = "MOST_SparePart" + moment(new Date()).format("DD_MM_YYYY_HH_mm_ss") + ".xlsx"; //name with date time & extension
        link.setAttribute("download", filename); //or any other extension
        document.body.appendChild(link);
        link.click();
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* downloadUnplannedExcelFile(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.downloadUnplannedExcelFile(action.payload);
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = url;
        const filename = "MOST_SparePart_Usage" + moment(new Date()).format("DD_MM_YYYY_HH_mm_ss") + ".xlsx"; //name with date time & extension
        link.setAttribute("download", filename); //or any other extension
        document.body.appendChild(link);
        link.click();
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* downloadPlannedExcelFile(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.downloadPlannedExcelFile(action.payload);
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = url;
        const filename = "MOST_SparePart_Usage" + moment(new Date()).format("DD_MM_YYYY_HH_mm_ss") + ".xlsx"; //name with date time & extension
        link.setAttribute("download", filename); //or any other extension
        document.body.appendChild(link);
        link.click();
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* watchAll() {
    yield takeEvery(actions.Types.SPARE_PARTS_EXCEL_GET_EXCEL_LIST, getExcelList);
    yield takeEvery(actions.Types.SPARE_PARTS_EXCEL_UPLOAD_FILE, getPostExcelUpload);
    yield takeEvery(actions.Types.SPARE_PARTS_EXCEL_EXCEL_FILE_OUTLINE, downloadExcelFile);
    yield takeEvery(actions.Types.SPARE_PARTS_UNPLANNED_EXCEL_FILE_OUTLINE, downloadUnplannedExcelFile);
    yield takeEvery(actions.Types.SPARE_PARTS_PLANNED_EXCEL_FILE_OUTLINE, downloadPlannedExcelFile);
}

const SparePartExcelSaga = [fork(watchAll)];

export default SparePartExcelSaga;
